import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Option } from '../inputs/select/options';
import { ActivatedRoute, Router } from '@angular/router';
import { CONTACT_US_SUBJECTS } from '../../constants/constants';
import { ContactUsService } from '../../services/contact-us.service';
import { RecaptchaComponent } from 'ng-recaptcha';

interface ContactUsForm {
  first_name: FormControl<string>;
  last_name: FormControl<string>;
  email: FormControl<string>;
  subject: FormControl<string>;
  message: FormControl<string>;
  token: FormControl<string>;
}

@Component({
  selector: 'app-contact-us-form',
  templateUrl: './contact-us-form.component.html',
  styleUrls: ['./contact-us-form.component.scss'],
})
export class ContactUsFormComponent {
  public subjectOptions: Option[] = CONTACT_US_SUBJECTS;
  public disableSubmit: boolean = false;

  @ViewChild('recaptcha') recaptcha: RecaptchaComponent;

  constructor(
    private contactUsService: ContactUsService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  public innerForm = new FormGroup<ContactUsForm>({
    first_name: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    last_name: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    email: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    subject: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    message: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    token: new FormControl('', {
      nonNullable: true,
    }),
  });

  resolveToken(token: string): void {
    this.innerForm.get('token')?.setValue(token);

    if (token) {
      this.submitData();
    }
  }

  submitForm(): void {
    this.disableSubmit = true;

    this.recaptcha.reset();
    this.recaptcha.execute();
  }

  submitData(): void {
    if (!this.innerForm.invalid) {
      this.contactUsService
        .create(this.innerForm.getRawValue())
        .subscribe(() => {
          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: { submitSuccess: 1 },
            queryParamsHandling: 'merge',
          });
        });
    }
    this.disableSubmit = false;
  }
}
